export default __webpack_public_path__ + "static/scam-latitude-protect-alert-3-2f53d4707aa606258b9a34cf5258e534.webp";